import Cookies from 'js-cookie'

const TokenKey = 'siva_dm_token'
const OpenIdKey = 'siva_dm_openid'
const UserNameKey = 'siva_dm_username'
const UserPhoneKey = 'siva_dm_userphone'
const UserNickNameKey = 'siva_dm_usernickname'

export function getToken() {
  return Cookies.get(TokenKey)
}

export function setToken(token) {
  return Cookies.set(TokenKey, token)
}

export function removeToken() {
  return Cookies.remove(TokenKey)
}

export function getOpenId() {
  return Cookies.get(OpenIdKey)
}

export function setOpenId(openid) {
  return Cookies.set(OpenIdKey, openid)
}

export function removeOpenId() {
  return Cookies.remove(OpenIdKey)
}

export function getUserName() {
  return Cookies.get(UserNameKey)
}

export function setUserName(username) {
  return Cookies.set(UserNameKey, username)
}

export function removeUserName() {
  return Cookies.remove(UserNameKey)
}

export function getUserPhone() {
  return Cookies.get(UserPhoneKey)
}

export function setUserPhone(userphone) {
  return Cookies.set(UserPhoneKey, userphone)
}

export function removeUserPhone() {
  return Cookies.remove(UserPhoneKey)
}

export function getUserNickName() {
  return Cookies.get(UserNickNameKey)
}

export function setUserNickName(usernickname) {
  return Cookies.set(UserNickNameKey, usernickname)
}

export function removeNickUserName() {
  return Cookies.remove(UserNickNameKey)
}
